export default __webpack_public_path__ + "static/media/import-orders-xlsx-example-en.929568e4.xlsx";